import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {
  IPitFinancingRedistributionBySourceLite,
  PitFinancingRedistributionBySourceLite
} from "./pit-financing-redistribution-by-source-lite";

export interface IPitFinancingRedistributionLite {

  _id: number;

  _financingRedistributionBySource: IPitFinancingRedistributionBySourceLite[];

  sourceActivityVersionId: number;
}


@jsonObject
export class PitFinancingRedistributionLite implements IPitFinancingRedistributionLite {

  /**
   * должен соответсвовать {@link PitFinancingRedistribution} id
   */
  @jsonMember({name:'id', constructor: Number, emitDefaultValue: false, isRequired: false })
  _id: number;

  @jsonArrayMember(PitFinancingRedistributionBySourceLite, {name:'financingRedistributionBySource', emitDefaultValue: false, preserveNull: false, isRequired: false})
  _financingRedistributionBySource: PitFinancingRedistributionBySourceLite[];

  @jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false })
  sourceActivityVersionId: number;

}
